import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path d="M20 7H15V2L20 7Z" fill="currentColor" />
    <path
      d="M11.852 9.875C11.82 9.879 11.803 9.887 11.799 9.89C11.774 9.922 11.749 10.095 11.863 10.48C11.892 10.174 11.88 9.971 11.852 9.875Z"
      fill="currentColor"
    />
    <path
      d="M8.88105 18.037L8.94505 18.072C9.11705 18.072 9.55905 17.734 10.003 16.983C10.011 16.97 10.021 16.952 10.032 16.929C9.24205 17.407 8.86205 17.892 8.88105 18.037Z"
      fill="currentColor"
    />
    <path
      d="M12.1081 12.8051C11.8991 13.5721 11.6141 14.5871 11.3411 15.4721C11.5071 15.4051 11.5941 15.3761 11.7971 15.3071C12.0211 15.2311 12.3881 15.1081 13.1751 14.8261C13.1771 14.8251 13.1791 14.8251 13.1811 14.8241L13.1711 14.8101L13.1851 14.8061C12.8311 14.2071 12.4371 13.4521 12.1081 12.8051V12.8051Z"
      fill="currentColor"
    />
    <path
      d="M14.4419 15.28C14.6969 15.485 15.1109 15.434 15.1359 15.411C15.1229 15.427 15.1229 15.366 15.1019 15.339C15.0569 15.282 14.8129 15.223 14.4419 15.28V15.28Z"
      fill="currentColor"
    />
    <path
      d="M14 8V2H6.286C5.023 2 4 2.895 4 4V20C4 21.105 5.023 22 6.286 22H17.715C18.977 22 20 21.105 20 20V8H14ZM14.927 16.234C14.561 16.234 14.2 16.089 13.912 15.827C13.826 15.749 13.731 15.638 13.622 15.487C13.556 15.509 13.488 15.532 13.418 15.557C12.624 15.841 12.252 15.966 12.027 16.042C11.689 16.156 11.689 16.157 11.03 16.435L11.029 16.436C10.815 17.056 10.704 17.276 10.637 17.388C10.378 17.826 9.694 18.845 8.945 18.845C8.702 18.845 8.486 18.739 8.319 18.539C8.156 18.344 8.1 18.09 8.161 17.826C8.333 17.082 9.406 16.313 10.436 15.853C10.85 14.595 11.35 12.765 11.58 11.898C11.583 11.863 11.59 11.827 11.599 11.787L11.585 11.76C11.042 10.675 10.904 9.932 11.163 9.489C11.268 9.31 11.483 9.097 11.914 9.097C12.114 9.097 12.293 9.186 12.416 9.348C12.514 9.476 12.81 9.864 12.446 11.504C12.436 11.56 12.42 11.627 12.399 11.712C12.798 12.512 13.434 13.777 13.935 14.594C14.811 14.381 15.38 14.47 15.677 14.849C15.837 15.052 15.898 15.331 15.843 15.613C15.771 15.984 15.403 16.234 14.927 16.234V16.234Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'FilePdf');

export default Icon;
